import gql from "graphql-tag";
const INTEGRATION_SYSTEMS = gql`
	query integrationSystems(
		$skip: Int
		$take: Int
		$where: IntegrationSystemFilterInput
		$order: [IntegrationSystemSortInput!]
	) {
		integrationSystems(
			skip: $skip
			take: $take
			where: $where
			order: $order
		) {
			items {
				id
				name
				settings
				settingsScheme
			}
		}
	}
`;
const INTEGRATION_SYSTEMS_LOOKUP = gql`
	query integrationSystemsLookup(
		$skip: Int
		$take: Int
		$where: BaseLookupFilterInput
		$order: [BaseLookupSortInput!]
	) {
		integrationSystemsLookup(
			skip: $skip
			take: $take
			where: $where
			order: $order
		) {
			items {
				id
				name
			}
		}
	}
`;
const INTEGRATION_SYSTEMS_LOGS = gql`
	query integrationSystemLogs(
		$skip: Int
		$take: Int
		$where: IntegrationSystemLogFilterInput
		$order: [IntegrationSystemLogSortInput!]
	) {
		integrationSystemLogs(
			skip: $skip
			take: $take
			where: $where
			order: $order
		) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				status
				request
				response
				method
				direction
				responseStatusCode
				error
				createdOn
				duration
				integrationSystemId
				integrationSystem {
					name
				}
			}
		}
	}
`;
const CHANGE_INTEGRATION_SYSTEM_SETTINGS = gql`
	mutation changeIntegrationSystemSettings(
		$input: IntegrationSystemSettingsInput!
	) {
		changeIntegrationSystemSettings(input: $input) {
			settings
			settingsScheme
			name
			description
			id
			createdOn
			createdById
			modifiedOn
			modifiedById
			isDeleted
		}
	}
`;
export {
  CHANGE_INTEGRATION_SYSTEM_SETTINGS,
  INTEGRATION_SYSTEMS,
  INTEGRATION_SYSTEMS_LOGS,
  INTEGRATION_SYSTEMS_LOOKUP
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
